import { useStore } from '@modules';
import { FiatCurrencyEnum } from '@modules/global/types';

const useIsRapydAvailable = (): boolean => {
  const [{ global }] = useStore();
  return global.currencies.fiat.includes(FiatCurrencyEnum.IDR);
};

export default useIsRapydAvailable;
